import {CampaignData} from './dcp-campaign-data';

export type FormType = 'NL' | 'EV' | 'FT' | 'CP' | 'CT' | 'RG' | 'PU' | 'WR' | 'SA' | 'WEB';

export class FormData {
  events?: {
    formView?: boolean;
    formSubmit?: boolean;
    error?: boolean;
  };
  form?: {
    uniqueID: string;
    name: string;
    referrer?: string;
    transactionID?: string;
    country?: string;
    campaign_data?: CampaignData;
  };
  ecommerce?: {
    products: {
      ID: string;
      name: string;
      partnerName: string;
    }[];
  };
  error?: {
    description: string;
  };
}
